import type { UserSessionData } from "@usercentrics/cmp-browser-sdk";
import type { InitialConfig, RawData, UserLocation } from "./types";

/**
 * Type guard to ensure config has the correct shape and types.
 * @param config unknown object from the native app.
 * @returns
 */

export const isInitialConifg = (config: unknown): config is InitialConfig => {
    if (typeof config !== "object") {
        return false;
    }

    if (config === null) {
        return false;
    }

    if (Array.isArray(config)) {
        return false;
    }

    return (
        Object.prototype.hasOwnProperty.call(config, "i18n") &&
        Object.prototype.hasOwnProperty.call(config, "isPay") &&
        Object.prototype.hasOwnProperty.call(config, "mobileWebType") &&
        Object.prototype.hasOwnProperty.call(config, "ucSettingsId")
    );
};

export const isUserSessionData = (data: unknown): data is UserSessionData => {
    if (typeof data !== "object") {
        return false;
    }

    if (data === null) {
        return false;
    }

    if (Array.isArray(data)) {
        return false;
    }

    return (
        Object.prototype.hasOwnProperty.call(data, "ccpa") &&
        Object.prototype.hasOwnProperty.call(data, "consents") &&
        Object.prototype.hasOwnProperty.call(data, "controllerId") &&
        Object.prototype.hasOwnProperty.call(data, "language") &&
        Object.prototype.hasOwnProperty.call(data, "tcf")
    );
};

export const isRawData = (data: unknown): data is RawData => {
    if (typeof data !== "object") {
        return false;
    }

    if (data === null) {
        return false;
    }

    if (Array.isArray(data)) {
        return false;
    }

    return Object.prototype.hasOwnProperty.call(data, "rawData");
};

export const isUserLocation = (location: unknown): location is UserLocation => {
    if (typeof location !== "object") {
        return false;
    }

    if (location === null) {
        return false;
    }

    if (Array.isArray(location)) {
        return false;
    }

    return (
        Object.prototype.hasOwnProperty.call(location, "lat") &&
        Object.prototype.hasOwnProperty.call(location, "lng")
    );
};
